module.exports = __webpack_public_path__ + "img/eg.02c7cde8.svg";